import React, { useEffect } from 'react';
import {
  NavigationType,
  Outlet,
  useBlocker,
  useMatch,
  useNavigate,
} from 'react-router';
import {
  closeTopOverlay,
  getCurrentUrl,
  hasOpenOverlay,
  isFirstHistoryEntry,
  isOnHistoryFloor,
  resetHistoryFloor,
  runAfterBackIsCancelled,
} from '@/router/backNavigation';
import { ROUTE_HOME } from '@/router/routes';
import { ignoreBackUntilFirstInteraction } from '@/router/watchBack';

export const BackNavigationGuard: React.FC = () => {
  const navigate = useNavigate();
  const isOnHome = useMatch(ROUTE_HOME) !== null;
  const blocker = useBlocker(
    ({ historyAction }) =>
      historyAction === NavigationType.Pop &&
      (hasOpenOverlay() || isOnHistoryFloor()),
  );

  useEffect(() => {
    if (isFirstHistoryEntry()) {
      resetHistoryFloor();
      navigate(getCurrentUrl(), { replace: false });
    }

    return ignoreBackUntilFirstInteraction();
  }, [navigate]);

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }

    blocker.reset();

    if (hasOpenOverlay()) {
      closeTopOverlay();
      return;
    }

    if (!isOnHome) {
      runAfterBackIsCancelled(() => navigate(ROUTE_HOME, { replace: true }));
    }
  }, [blocker, navigate, isOnHome]);

  return <Outlet />;
};
